import { RootState } from '@store';

export const loadingSelector = (state: RootState) => state.loading;
export const loadingOpenSelector = (state: RootState) => state.loading.open;
